import CasesHighlightsBlock from "../cases-highlights-block/cases-highlights-block";
import "./cases-metrics-block.sass";

type Props = {
  heading: string;
  description: string;
  stats: {
    id: string;
    color: { hex: string };
    description: string;
    number: string;
  }[];
};
const CasesMetricsBlock = ({ heading, description, stats }: Props) => {
  return (
    <div className="cases-metrics-block">
      <div className="cases-metrics-block__content">
        <div className="cases-metrics-block__container">
          <div className="cases-metrics-block__heading">{heading}</div>
          <div className="cases-metrics-block__description">{description}</div>
        </div>

        <CasesHighlightsBlock
          className="cases-metrics-block__highlights"
          stats={stats}
        />
      </div>
    </div>
  );
};

export default CasesMetricsBlock;
